var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0754 34.6L30.4254 32H19.7754C18.2421 32 16.9421 31.4667 15.8754 30.4C14.8087 29.3333 14.2754 28.0333 14.2754 26.5C14.2754 25.2167 14.6712 24.075 15.4629 23.075C16.2546 22.075 17.2754 21.4333 18.5254 21.15C18.5754 21.0167 18.6254 20.8875 18.6754 20.7625C18.7254 20.6375 18.7754 20.5 18.8254 20.35L14.6754 16.2L16.0754 14.8L34.4754 33.2L33.0754 34.6ZM19.7754 30H28.4254L20.3754 21.95C20.3421 22.1333 20.3171 22.3083 20.3004 22.475C20.2837 22.6417 20.2754 22.8167 20.2754 23H19.7754C18.8087 23 17.9837 23.3417 17.3004 24.025C16.6171 24.7083 16.2754 25.5333 16.2754 26.5C16.2754 27.4667 16.6171 28.2917 17.3004 28.975C17.9837 29.6583 18.8087 30 19.7754 30ZM34.8754 30.75L33.4254 29.35C33.7087 29.1167 33.9212 28.8458 34.0629 28.5375C34.2046 28.2292 34.2754 27.8833 34.2754 27.5C34.2754 26.8 34.0337 26.2083 33.5504 25.725C33.0671 25.2417 32.4754 25 31.7754 25H30.2754V23C30.2754 21.6167 29.7879 20.4375 28.8129 19.4625C27.8379 18.4875 26.6587 18 25.2754 18C24.8254 18 24.3921 18.0542 23.9754 18.1625C23.5587 18.2708 23.1587 18.4417 22.7754 18.675L21.3254 17.225C21.9087 16.825 22.5296 16.5208 23.1879 16.3125C23.8462 16.1042 24.5421 16 25.2754 16C27.2254 16 28.8796 16.6792 30.2379 18.0375C31.5962 19.3958 32.2754 21.05 32.2754 23C33.4254 23.1333 34.3796 23.6292 35.1379 24.4875C35.8962 25.3458 36.2754 26.35 36.2754 27.5C36.2754 28.15 36.1504 28.7542 35.9004 29.3125C35.6504 29.8708 35.3087 30.35 34.8754 30.75Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24685",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24685",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineIcon);
export default __webpack_public_path__ + "static/media/offline-icon.39c66f513c97c16adf3b6672df03db9e.svg";
export { ForwardRef as ReactComponent };